import {Inject, Injectable} from "@angular/core";
import {IQrCodeModalService} from "./i-qr-code-modal.service";
import {QrCodeModalComponent} from "./qr-code-modal.component";
import {IModalService, modalServiceInjectionToken} from "@zaeper/angular-dashboard-view-lib";
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Injectable()
export class QrCodeModalService implements IQrCodeModalService {
  private _dialogRef: DynamicDialogRef | null = null;

  constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {}

  open(connectionCode: string): void {
    this._dialogRef = this._modalService.open(QrCodeModalComponent, {
      styleClass: "bg-white rounded-lg",
      showHeader: false,
      closable: false,
      width: "auto",
      closeOnEscape: true,
      dismissableMask: true,
      data: { connectionCode }
    });
  }

  close(): void {
    if (this._dialogRef) {
      this._dialogRef.close();
      this._dialogRef = null;
    }
  }
}
